import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "layout/DashboardLayout";
import Error from "layout/Error";
import Error404 from "pages/Errors/Error404";
import Error500 from "pages/Errors/Error500";
import Error401 from "pages/Errors/Error401";

const RoleAccess = lazy(() => import("pages/AccessManagement/RoleAccess"));
const User = lazy(() => import("pages/AccessManagement/User"));
const RoleList = lazy(() => import("pages/AccessManagement/Roles"));
const UserManageObject = lazy(() => import("pages/AccessManagement/Objects"));
const ObjectPage = lazy(() => import("pages/AccessManagement/Objects/components/ObjectPage"));
const ZohoDashboard = lazy(() => import("pages/Dashboards/ZohoDashboard"));
 
const routes = [
  {
    path: "/",
    element: <Navigate to="/zoho-dashboards" />,
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      
      {
        path: "zoho-dashboards",
        element: <ZohoDashboard />,
      },
      {
        path: "role_access",
        element: <RoleAccess />,
      },
      {
        path: "user",
        element: <User />,
      },
      {
        path: "roles",
        element: <RoleList />,
      },
      {
        path: "object",
        element: <UserManageObject />,
      },
      
      {
        path: "object/add",
        element: <ObjectPage/>,
      },
      {
        path: "object/edit",
        element: <ObjectPage/>,
      },
      {
        path: "errors",
        children: [
          {
            path: "error-404",
            element: <Error404 />,
          },
          {
            path: "error-500",
            element: <Error500 />,
          },
          {
            path: "error-401",
            element: <Error401 />,
          },
        ],
      },
      
      // Catch-all route for undefined paths (404)
      /*{
        path: "*", // This matches all undefined routes
        element: <Navigate to="/errors/error-404" replace />, // Redirect to the 404 page
      },*/
     
    ],
  },
  // Separate 404 route if you want direct access to the 404 page
  /*{
    path: "/errors/error-404",
    element: <Error404Page />,
  },*/ // {
  //   path: "/errors",
  //   element: <Error />,  // Error layout
  //   children: [
  //     { path: "error-404", element: <Error_404 /> },  // Error page as a child route
  //     { path: "*", element: <Error_404 /> },  // Wildcard for unmatched routes under /errors
  //   ],
  // },
  {
    path: "*",
    element: <Navigate to="/errors/error-404" replace />,
  },
];

export default routes;